<script setup>
import { useCheckoutStepTracking } from "@/mixins/tracking/checkout-steps";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useContextStore } from "@/store/context";
import { useCheckoutStore } from "@/store/checkout";
import { useMagasinStore } from "@/store/magasin";
import apiMagasinModePaiement from "@/services/http/api-drive/magasin/modePaiement";
import { useClientStore } from "@/store/client";
import fideliteApiDrive from "@/services/http/api-drive/client/fidelite";

definePageMeta({
  layout: "commander",
  middleware: ["authenticated", "tunnel-go-first-step"]
});
const { trackCheckOutStep } = useCheckoutStepTracking();

const { fetchFidelities } = useClientStore();
const { fidelitesMeta, fidelites: fideliteClient } = storeToRefs(
  useClientStore()
);

const app = useNuxtApp();

const { layout } = storeToRefs(useContextStore());
const {
  checkout,
  typePanier,
  serviceId,
  id: checkoutId,
  modesPaiement,
  modesPaiementInfos,
  selectedPaymentId
} = storeToRefs(useCheckoutStore());

selectedPaymentId.value = null;

const { id: magasinId, getServiceById } = storeToRefs(useMagasinStore());

const fidelites = ref([]);
const carteCoraIsMalinPlus = ref(null);

const { getErrorStatus, getErrorMessage } = useAxiosHelper();

const { setStepValue, fetchModesPaiement } = useCheckoutStore();

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/commander/paiement-et-avantages/${layout.value}.vue`
    ]
  );
});

if (!checkout.value || !checkout.value.attributes.service_id) {
  await navigateTo(
    {
      path: "/commander",
      query: { type_panier: typePanier.value }
    },
    { replace: true }
  );
}

const serviceHasReservationEuroCarrefour = computed(() => {
  const service = getServiceById.value(serviceId.value);
  return service ? service.reservation_eurocarrefour : false;
});

onMounted(() => {
  trackCheckOutStep(trackingCodes.LABELGA.fourth, 4);
  setStepValue(2);
});

try {
  await fetchModesPaiement();
} catch (error) {
  throw showError({
    statusCode: getErrorStatus(error, 504),
    statusMessage: getErrorMessage(error)
  });
}

try {
  await fetchFidelities();
  fidelites.value = fideliteClient.value.filter(
    (card) => card.attributes.sous_type === "CRF"
  );
} catch (err) {
  console.log(err);
}
</script>

<template>
  <component
    :is="component"
    :payment-methods="modesPaiement"
    :payment-methods-infos="modesPaiementInfos"
    :carte-cora-is-malin-plus="carteCoraIsMalinPlus"
    :is-service-compatible-euro-carrefour="serviceHasReservationEuroCarrefour"
    :fidelites="fidelites"
  />
</template>
